import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import utils from "Root/profile/utils";
import styles from "./styles.module.scss";
import subscriptionStyles from "../../SubscriptionItem/styles.module.scss";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import H4Font from "Root/profile/components/common/H4Font";
import RegFont from "Root/profile/components/common/RegFont";
import LargeFont from "Root/profile/components/common/LargeFont";
const AdditionalProduct = ({ image_url, title, onAdd, attributes, item_type, net_price, gross_price, servings, quantity, bags_info, available_flavors, delivery_cadence, }) => {
    const onAddItem = () => {
        onAdd(item_type);
    };
    const getAtrributesString = () => {
        const bagsAttr = bags_info.map((item) => {
            const attr = item.attributes
                .map((a) => (a.attribute_on ? a.attribute_on_text : a.attribute_off_text))
                .join(" + ");
            return attr;
        });
        return bagsAttr.join(", ");
    };
    const getFlavorString = () => {
        const bagsFlavors = bags_info
            .map((item) => item.selected_flavors.filter((f) => f.count).map((f) => f.short_name))
            .flat();
        const flavorString = available_flavors
            .map((item) => {
            const bagFlavor = bagsFlavors.find((f) => f === item.short_name);
            if (bagFlavor) {
                return item.full_name;
            }
            return "";
        })
            .filter((item) => item);
        return flavorString ? flavorString.join(", ") : "No Flavors";
    };
    const getQuanityString = (qty) => {
        if (utils.isAdditionalItem(item_type)) {
            return `1 Item`;
        }
        if (["creatine", "preworkout", "collagen", "fiber"].includes(item_type)) {
            return `${qty} Jar${qty > 1 ? "s" : ""} | ${servings} servings`;
        }
        return `${qty} Bag${qty > 1 ? "s" : ""} | ${servings} servings`;
    };
    const blenderBottleString = item_type === "blenderbottle" && `20 oz. | ${delivery_cadence}`;
    const waterbottleString = (item_type === "wb221" || item_type === "wb222") && `22 oz. | ${delivery_cadence}`;
    const getCategory = () => {
        if (utils.getIsBooster(item_type)) {
            return "Performance Boost";
        }
        if (item_type === "greens") {
            return "";
        }
        return "Personalized";
    };
    const getTitle = () => {
        if (utils.getIsBooster(item_type)) {
            return title.replace("Performance Boosts", "");
        }
        return title;
    };
    return (_jsxs("div", { className: styles.additional_item, children: [_jsxs("div", { className: styles.info_wrapper, children: [_jsx("div", { className: styles.addition_item_img_wrapper, children: _jsx("img", { src: image_url, alt: "" }) }), _jsx(Eyebrow, { children: getCategory() }), _jsx("div", { className: styles.title, children: _jsx(H4Font, { fontWeight: 400, children: getTitle() }) }), _jsx("span", { className: subscriptionStyles.subscription_item_price, children: net_price === gross_price ? (_jsx(RegFont, { children: gross_price })) : (_jsxs(_Fragment, { children: [_jsx("span", { className: styles.old_price, children: _jsx(RegFont, { children: gross_price }) }), "\u00A0", _jsx(RegFont, { color: "#77b1ac", children: net_price })] })) }), !utils.isAdditionalItem(item_type) && (_jsx("div", { className: styles.quantity, children: _jsx(LargeFont, { children: getQuanityString(quantity) }) })), waterbottleString && (_jsx("span", { className: styles.quantity, children: _jsx(LargeFont, { children: waterbottleString }) })), blenderBottleString && (_jsx("span", { className: styles.quantity, children: _jsx(LargeFont, { children: blenderBottleString }) })), !utils.isAdditionalItem(item_type) && !utils.getIsBooster(item_type) && (_jsxs("div", { className: styles.flavors, children: [_jsx(RegFont, { fontWeight: 400, children: "Flavors:\u00A0" }), _jsx(RegFont, { children: getFlavorString() })] })), !utils.isAdditionalItem(item_type) && !utils.getIsBooster(item_type) && item_type !== "protein" && (_jsxs("div", { className: styles.flavors, children: [_jsx(RegFont, { fontWeight: 400, children: "Customizations:\u00A0" }), _jsx(RegFont, { children: getAtrributesString() })] }))] }), _jsx("div", { className: styles.button_wrapper, children: _jsx(RoundedGainfulButton, { label: "Add", onClick: onAddItem }) })] }));
};
export default AdditionalProduct;
